
export const StuckIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.57502 3.21635L1.51668 14.9997C1.37116 15.2517 1.29416 15.5374 1.29334 15.8284C1.29253 16.1195 1.36793 16.4056 1.51204 16.6585C1.65615 16.9113 1.86396 17.122 2.11477 17.2696C2.36559 17.4171 2.65068 17.4965 2.94168 17.4997H17.0583C17.3494 17.4965 17.6344 17.4171 17.8853 17.2696C18.1361 17.122 18.3439 16.9113 18.488 16.6585C18.6321 16.4056 18.7075 16.1195 18.7067 15.8284C18.7059 15.5374 18.6289 15.2517 18.4834 14.9997L11.425 3.21635C11.2765 2.97144 11.0673 2.76895 10.8177 2.62842C10.5681 2.48789 10.2865 2.41406 10 2.41406C9.71357 2.41406 9.43196 2.48789 9.18235 2.62842C8.93275 2.76895 8.72358 2.97144 8.57502 3.21635Z"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 6.66699V10.0003"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 14.167H10.0083"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
